import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '../../services/auth/authentication.service';
import { ApiService } from '../../services/api/api.service';
import { FormatService } from '../../services/format/format.service';
import * as moment from "moment";

@Component({
  selector: 'app-subscribe-voucher',
  templateUrl: './subscribe-voucher.component.html',
  styleUrls: ['./subscribe-voucher.component.css']
})
export class SubscribeVoucherComponent implements OnInit {
  isData : any = [];
  isTotalAll : number = 0;
  isKeyword : string = '';
  isType : string = '';

  isPage : number = 1;
  isPageSize : number = 10;
  isPages : any = [];
  isTableLoading : boolean = false;

  constructor(
    private toastr: ToastrService,
    private authService: AuthenticationService,
    private apiService: ApiService,
    private formatService: FormatService,
  ) { }

  ngOnInit(): void {
    this.isPageSize = this.apiService.LIMIT || 10;
    this.getData();
  }

  private searchTimer : any;
  private lastQuery : string = '';

  onKeywordInput(value : string){
    this.isKeyword = value;
    clearTimeout(this.searchTimer);
    // debounce: wait 450ms after the last keystroke before hitting the API
    this.searchTimer = setTimeout(() => this.applyFilter(), 450);
  }

  async applyFilter(){
    clearTimeout(this.searchTimer);
    const query = `${this.isKeyword}|${this.isType}`;
    if(query === this.lastQuery){ return; } // query unchanged, skip the request
    this.lastQuery = query;
    this.isPage = 1;
    await this.getData();
  }

  async getData(){
    let searchData = {"keyword":this.isKeyword, "type":this.isType};
    const offset = (this.isPage - 1) * this.isPageSize;
    this.isTableLoading = true;
    try{
      this.apiService.methodGetSilent(`user-voucher/${offset}/${encodeURIComponent(JSON.stringify(searchData))}`,this.authService.getToken()).subscribe((response)=>{
        this.isTableLoading = false;
        if(response && response.status == 200) {
          this.isData = [];
          (response.total ? response.data.forEach((element: any) => {
            // relations can be null — must never break the render
            element.userName = element.user ? element.user.name : '-';
            if(!element.voucher){ element.voucher = {code: '-', name: '-', type: null, expired_day: 0}; }
            element.createdVw = moment(element.createdAt).locale('id').format("D MMMM YYYY");
            element.expiredVw = element.expired_date ? moment(element.expired_date).locale('id').format("D MMMM YYYY") : '-';
            element.isActive = element.expired_date ? moment(element.expired_date).isSameOrAfter(moment(), 'day') : false;
            this.isData.push(element);
          }) : false);
          this.isTotalAll = response.total || 0;
          this.buildPager();
        }
      }, () => { this.isTableLoading = false; })
    }catch(error){
      this.isTableLoading = false;
      console.log(error);
    }
  }

  totalPages(){
    return Math.max(1, Math.ceil(this.isTotalAll / this.isPageSize));
  }
  buildPager(){
    const total = this.totalPages();
    const pages: any[] = [];
    for(let p = 1; p <= total; p++){
      if(p == 1 || p == total || Math.abs(p - this.isPage) <= 1){
        pages.push(p);
      }else if(pages[pages.length - 1] != '...'){
        pages.push('...');
      }
    }
    this.isPages = pages;
  }
  async goToPage(p: any){
    const total = this.totalPages();
    if(p < 1 || p > total || p == this.isPage){ return; }
    this.isPage = p;
    await this.getData();
  }
  rowNo(i: number){
    return (this.isPage - 1) * this.isPageSize + i + 1;
  }
  summaryFrom(){
    return this.isTotalAll ? (this.isPage - 1) * this.isPageSize + 1 : 0;
  }
  summaryTo(){
    return (this.isPage - 1) * this.isPageSize + this.isData.length;
  }
  formatNumber(value : any){
    return this.formatService.dotFormat(value || 0);
  }

  // wrap keyword matches in <mark> for the list; input is HTML-escaped first
  highlight(text : any){
    const esc = String(text == null ? '' : text)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const keyword = this.isKeyword.trim();
    if(!keyword){ return esc; }
    const escapedKeyword = keyword
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // neutralize regex metacharacters
    return esc.replace(new RegExp(`(${escapedKeyword})`, 'gi'), '<mark class="vl-hl">$1</mark>');
  }

  copyCode(code : string){
    const done = () => this.toastr.success(`Kode ${code} disalin`);
    const nav: any = navigator;
    if(nav.clipboard && nav.clipboard.writeText){
      nav.clipboard.writeText(code).then(done);
    }else{
      const ta = document.createElement('textarea');
      ta.value = code;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      done();
    }
  }
}
